import Radio from '@mos-cat/radio';
import { connect } from 'dva';
import React from 'react';
import { Dispatch } from 'redux';
import { MARITAL_STATUS } from '../../../constants/applicant';
import { BORN_IN, BORN_IN_MARRIAGE } from '../../../constants/child';
import { CHILD_FIELD_NAME } from '../../../constants/fieldNames';
import { getPayload } from '../../../helpers/handlers';
import { i18n } from '../../../helpers/i18n';
import { select, t } from '@lingui/macro';

function ChildBornInNotCurrentMarriage({
  applicantSex,
  isVisible,
  bornInNotCurrentMarriage,
  onChange,
}) {
  if (!isVisible) return null;
  const { value, error, disabled } = bornInNotCurrentMarriage;
  return (
    <div className="StepContentBlock">
      <div className="PguFormGrid__row">
        <Radio
          className="PguFormGrid_col"
          label={i18n._(
            t`Ребёнок заявителя, рожденный в прежнем браке или вне брака`
          )}
          name={CHILD_FIELD_NAME.bornInNotCurrentMarriage}
          value={BORN_IN_MARRIAGE.ofApplicant}
          checked={value === BORN_IN_MARRIAGE.ofApplicant}
          error={error}
          disabled={disabled}
          onChange={onChange}
        />
      </div>
      <div className="PguFormGrid__row">
        <Radio
          className="PguFormGrid_col"
          label={i18n._(
            select({
              value: applicantSex,
              m:
                'Ребёнок супруги заявителя, рожденный в прежнем браке или вне брака',
              f:
                'Ребёнок супруга заявителя, рожденный в прежнем браке или вне брака',
              other:
                'Ребёнок супруги (супруга) заявителя, рожденный в прежнем браке или вне брака',
            })
          )}
          name={CHILD_FIELD_NAME.bornInNotCurrentMarriage}
          value={BORN_IN_MARRIAGE.ofSpouse}
          checked={value === BORN_IN_MARRIAGE.ofSpouse}
          error={error}
          disabled={disabled}
          onChange={onChange}
        />
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange(event) {
    const payload = getPayload(event);
    dispatch({
      type: 'child/onChange',
      payload,
    });

    dispatch({
      type: 'child/secondParent/validateMarriageDate',
    });
  },
});

export default connect(
  ({
    applicant: {
      sex: { value: sex },
      married: { value: married },
    },
    child: { bornInCurrentMarriage, bornInNotCurrentMarriage },
  }) => ({
    applicantSex: sex,
    isVisible:
      married === MARITAL_STATUS.married &&
      bornInCurrentMarriage.value === BORN_IN.notCurrentMarriage,
    bornInNotCurrentMarriage,
  }),
  mapDispatchToProps
)(ChildBornInNotCurrentMarriage);
